<template>
  <div id="content" class="main-content">

  <progress-bar v-if="$root.isLoading"></progress-bar>
  <router-view v-else></router-view>
  </div>
</template>
<script>
import ProgressBar from './ProgressBar.vue';
export default {
  components: { ProgressBar },};
</script>
<style>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.1s;
}

.fade-enter,
  .fade-leave-to
  /* .fade-leave-active in <2.1.8 */

 {
  opacity: 0;
}
</style>
